import { useQuery } from "@tanstack/react-query";
import { vesselServices } from "./vessel.services";
import { QueryParams } from "../type";
import { VESSEL_KEYS } from "./vessel.keys";


export const useGetVesselTypes = (params?: QueryParams) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSEL_TYPES(params),
    queryFn: () => vesselServices.getVesselTypes(params),
  });
};

export const useGetVessels = (params?: QueryParams) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSELS(params),
    queryFn: () => vesselServices.getAllVessel(params),
  });
};

export const useGetVesselsForDropdown = () => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSELS_DROPDOWN(),
    queryFn: () => vesselServices.getVesselsForDropdown(),
  });
};

export const useGetVesselAssignments = () => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSEL_ASSIGNMENTS(),
    queryFn: () => vesselServices.getVesselAssignments(),
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
};

export const useGetTodayVesselAssignments = () => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_TODAY_VESSEL_ASSIGNMENTS(),
    queryFn: () => vesselServices.getTodayVesselAssignments(),
    refetchInterval: 2 * 60 * 1000, // Refetch every 2 minutes for real-time updates
  });
};

export const useGetVesselLoadLists = (params?: QueryParams) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSEL_LOAD_LISTS(params),
    queryFn: () => vesselServices.getVesselLoadLists(params),
  });
};

export const useGetVesselLoadList = (vesselId: string, params?: QueryParams) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSEL_LOAD_LIST(vesselId, params),
    queryFn: () => vesselServices.getVesselLoadList(vesselId, params),
    enabled: !!vesselId, // Only run query if vesselId is provided
  });
};

export const useGetVesselById = (id?: string) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_VESSEL_BY_ID(id || ""),
    queryFn: () => vesselServices.getVesselById(id!),
    enabled: !!id,
  });
};

export const useGetShuttles = (params?: QueryParams) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_SHUTTLES(params),
    queryFn: () => vesselServices.getShuttles(params),
  });
};

export const useGetShuttleById = (id?: string) => {
  return useQuery({
    queryKey: VESSEL_KEYS.GET_SHUTTLE_BY_ID(id!),
    queryFn: () => vesselServices.getShuttleById(id!),
    enabled: !!id,
  });
};
